<app-location-contact-info />
<nz-divider></nz-divider>

<app-location-schedule />
